export default "/_next/static/images/ai_refine-63a38793ac124b4f4a1d9be9049ebd2a.png";